import type {MessageGrowlItem} from '@Components/message-growl';
import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import {IconSize} from '@Components/icon-v2/icon.types';

export const PANEL_SMALL_BREAKING_POINT = 550;

export const PANEL_SMALL_CONTAINER_QUERY: ContainerQueryObject = {
  small: {
    minWidth: 0,
    maxWidth: PANEL_SMALL_BREAKING_POINT,
  },
  large: {
    minWidth: PANEL_SMALL_BREAKING_POINT + 1,
  },
};

export const PANEL_HEADER_ICON_SIZE = IconSize.SIZE_ICON_20;

export enum PANEL_MESSAGE_TYPE {
  NONE = 'NONE',
  WARNING = 'WARNING',
  INFO_PRIMARY = 'INFO_BLUE',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INFO_NEUTRAL = 'INFO_NEUTRAL',
}

export interface PanelMessageProp {
  type: PANEL_MESSAGE_TYPE;
  message: string;
}

export interface BasePanel {
  panelId?: string;
  onBack?(artifact?: any): any;
  hideOnClose?: boolean;
  isOpenedInPopOver?: boolean;
}

export enum PanelDataKeys {
  GROWL = 'growlData',
}

enum PortedMessageGrowlProps {
  ICON = 'icon',
  TEXT = 'text',
}

export interface PanelGrowlData extends Pick<MessageGrowlItem, PortedMessageGrowlProps.ICON | PortedMessageGrowlProps.TEXT> {
  icon: string;
}
